import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Submit } from 'shared/components/Form';
import styles from './NotFound.module.scss';

const NotFound = ({ title, lines, ctaTitle, ctaRoute, withoutImage, className }) => {
  const navigate = useNavigate();

  const handleClick = () => navigate(ctaRoute);

  return (
    <div className={cn('row mb32', className)}>
      {!withoutImage && (
        <div className={`col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 ${styles.image}`}>
          <img src="/images/404.jpg" alt="" />
        </div>
      )}
      <div className={cn(withoutImage ? 'col-12' : 'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12', styles.text)}>
        {title && <h1>{title}</h1>}
        {lines.map((line, i) => (
          <p key={i}>{line}</p>
        ))}
        <p className={styles.btn}>
          <Submit title={ctaTitle} onClick={handleClick} />
        </p>
      </div>
    </div>
  );
};

NotFound.propTypes = {
  title: PropTypes.node,
  lines: PropTypes.arrayOf(PropTypes.node).isRequired,
  ctaTitle: PropTypes.string.isRequired,
  ctaRoute: PropTypes.string,
  withoutImage: PropTypes.bool,
  className: PropTypes.string,
};

NotFound.defaultProps = {
  title: null,
  ctaRoute: '/',
  withoutImage: false,
  className: null,
};

export default NotFound;
